import axiosInstance from '../../../axios/axios';

/**
 * Workshop Registration API Service
 * Handles HTTP requests related to workshop registration.
 */

/**
 * Register a participant for the workshop.
 *
 * @param {FormData} formData - Multipart form data
 * @returns {Promise<object>} API response data
 */
export const registerWorkshopParticipant = async (formData) => {
    const response = await axiosInstance.post('/WorkshopRegistration/Register', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    const data = response.data;
    const responseCode = data?.responseCode ?? data?.status?.responseCode;

    // Check if responseCode is not 200 (handles both string "200" and number 200)
    if (responseCode !== undefined && responseCode !== null && String(responseCode) !== '200') {
        const errorMsg =
            data?.responseText ||
            data?.result?.message ||
            data?.message ||
            data?.status?.detailedResponseCode ||
            data?.status?.message ||
            'Registration failed';

        const error = new Error(errorMsg);
        error.response = response;
        error.data = data;
        throw error;
    }

    return data;
};
